import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';

import { header, SearchResult, AdvancedSearch } from 'pages';


class App extends Component {

    render() {
        return (
            <div>
                {/*<Route path="/result" component={header}/>*/}

                <Switch>

                    <Route exact path="/result" component={SearchResult}/>
                    <Route exact path="/advanced" component={AdvancedSearch}/>
                </Switch>
            </div>
        );
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/shared/App.js